import React from 'react';
import validators from 'utils/validators';
import DropDownLink from '../../../../../common/dropdown-link';
import { LiveEvent } from '../../../state/types';
import EventDescription from './Description';

interface Props {
  liveEvent: LiveEvent;
  onEdit: (eventId: string) => void;
  onDuplicate: (eventId: string) => void;
  onDelete: (eventId: string) => void;
}

const EventListItem: React.FC<Props> = ({ liveEvent, onEdit, onDuplicate, onDelete }) => {
  const eventId = liveEvent.id || liveEvent.eventCode;
  const isViewEventPageVisible = liveEvent.url && validators.url(liveEvent.url);

  const onEditClick = (_: React.MouseEvent) => {
    onEdit(eventId);
  };

  const onDuplicateClick = (_: React.MouseEvent) => {
    onDuplicate(eventId);
  };

  const onViewEventPageClick = () => {
    window.open(liveEvent.url, '_blank');
  };

  const onDeleteClick = (_: React.MouseEvent) => {
    onDelete(eventId);
  };

  const dropdownItems = [
    <span key={'duplicate'} onClick={onDuplicateClick}>
      Duplicate
    </span>,
    isViewEventPageVisible && (
      <span key={'view_event'} onClick={onViewEventPageClick}>
        View event page
      </span>
    ),
    <span key={'delete'} onClick={onDeleteClick}>
      Delete
    </span>
  ].filter(Boolean);

  return (
    <li className={'live-event-item'}>
      <EventDescription
        title={liveEvent.title}
        startTime={liveEvent.start}
        endTime={liveEvent.end}
        timeZone={liveEvent.timeZone}
        isEmbedded={liveEvent.isEmbedded}
        onEditClick={onEditClick}
        createdAt={liveEvent.createdAt}
      />
      <div className={'theme-menu-container'}>
        <span className={'theme-menu-edit-button'} onClick={onEditClick}>
          Edit
        </span>
        <div className={'theme-menu-seperator'} />
        <div className={'dropdown-link-container'}>
          <DropDownLink items={dropdownItems} />
        </div>
      </div>
    </li>
  );
};

export default EventListItem;
